var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
var CardV2 = forwardRef(function (_a, ref) {
    var children = _a.children, enlarge = _a.enlarge, horizontal = _a.horizontal, ratio = _a.ratio, size = _a.size, download = _a.download, variation = _a.variation, noIcon = _a.noIcon, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "enlarge", "horizontal", "ratio", "size", "download", "variation", "noIcon", "className", "style"]);
    var enlargeClassName = "";
    if (enlarge === "link") {
        enlargeClassName = "fr-enlarge-link";
    }
    else if (enlarge === "button") {
        enlargeClassName = "fr-enlarge-button";
    }
    var cardClassNames = [
        "fr-card",
        enlargeClassName,
        horizontal ? "fr-card--horizontal" : "",
        ratio ? "fr-card--horizontal-".concat(ratio) : "",
        variation ? "fr-card--".concat(variation) : "",
        size && size !== "md" ? "fr-card--".concat(size) : "",
        download ? "fr-card--download" : "",
        noIcon ? "fr-card--no-icon" : "",
        className,
    ]
        .join(" ")
        .trim();
    return (React.createElement("div", __assign({}, otherProps, { ref: ref, className: cardClassNames, style: style }), children));
});
export default CardV2;
